import React from 'react';

import { fg } from '@atlaskit/platform-feature-flags';

export const TeamsSearchResultIcon = () => {
	return fg('rovo_search_custom_icon_component') ? (
		<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M25.9254 16.9079H33.6744C34.4065 16.9079 35 17.5123 35 18.2579V25.4462C35 28.1865 32.8188 30.4078 30.1282 30.4078H30.1051C27.4145 30.4082 25.233 28.1872 25.2326 25.4469C25.2326 25.4467 25.2326 25.4465 25.2326 25.4462V17.6135C25.2326 17.2238 25.5428 16.9079 25.9254 16.9079Z"
				fill="#5059C9"
			/>
			<path
				d="M31.1625 15.4868C32.8964 15.4868 34.3021 14.0553 34.3021 12.2894C34.3021 10.5236 32.8964 9.09207 31.1625 9.09207C29.4286 9.09207 28.023 10.5236 28.023 12.2894C28.023 14.0553 29.4286 15.4868 31.1625 15.4868Z"
				fill="#5059C9"
			/>
			<path
				d="M21.3953 15.4868C23.8999 15.4868 25.9302 13.4191 25.9302 10.8684C25.9302 8.31773 23.8999 6.25 21.3953 6.25C18.8908 6.25 16.8605 8.31773 16.8605 10.8684C16.8605 13.4191 18.8908 15.4868 21.3953 15.4868Z"
				fill="#7B83EB"
			/>
			<path
				d="M27.4421 16.9079H14.651C13.9276 16.9261 13.3554 17.5375 13.3722 18.2742V26.473C13.2712 30.894 16.7056 34.5628 21.0466 34.671C25.3875 34.5628 28.8219 30.894 28.7209 26.473V18.2742C28.7377 17.5375 28.1655 16.9261 27.4421 16.9079Z"
				fill="#7B83EB"
			/>
			<path
				opacity="0.1"
				d="M21.7441 16.9079V28.3971C21.7406 28.9239 21.4271 29.3972 20.9487 29.5978C20.7964 29.6635 20.6327 29.6973 20.4673 29.6973H13.986C13.8953 29.4628 13.8115 29.2284 13.7418 28.9868C13.4976 28.1715 13.3729 27.3239 13.372 26.4715V18.2721C13.3552 17.5366 13.9265 16.9261 14.6487 16.9079H21.7441Z"
				fill="black"
			/>
			<path
				opacity="0.2"
				d="M21.0464 16.9079V29.1076C21.0464 29.276 21.0132 29.4427 20.9487 29.5978C20.7518 30.085 20.287 30.4043 19.7697 30.4078H14.3139C14.1953 30.1734 14.0836 29.9389 13.986 29.6973C13.8883 29.4557 13.8115 29.2284 13.7418 28.9868C13.4976 28.1715 13.3729 27.3239 13.372 26.4715V18.2721C13.3552 17.5366 13.9265 16.9261 14.6487 16.9079H21.0464Z"
				fill="black"
			/>
			<path
				opacity="0.2"
				d="M21.0464 16.9079V27.6865C21.0411 28.4024 20.4726 28.9814 19.7697 28.9868H13.7418C13.4976 28.1715 13.3729 27.3239 13.372 26.4715V18.2721C13.3552 17.5366 13.9265 16.9261 14.6487 16.9079H21.0464Z"
				fill="black"
			/>
			<path
				opacity="0.2"
				d="M20.3487 16.9079V27.6865C20.3434 28.4024 19.7749 28.9814 19.072 28.9868H13.7418C13.4976 28.1715 13.3729 27.3239 13.372 26.4715V18.2721C13.3552 17.5366 13.9265 16.9261 14.6487 16.9079H20.3487Z"
				fill="black"
			/>
			<path
				opacity="0.1"
				d="M21.7443 13.2344V15.4726C21.6257 15.4797 21.5141 15.4868 21.3955 15.4868C21.2769 15.4868 21.1653 15.4797 21.0467 15.4726C20.8112 15.4567 20.5776 15.4186 20.349 15.3589C18.9362 15.0182 17.769 14.0091 17.2095 12.6447C17.1132 12.4156 17.0384 12.1777 16.9862 11.9342H20.4676C21.1716 11.9369 21.7417 12.5175 21.7443 13.2344Z"
				fill="black"
			/>
			<path
				opacity="0.2"
				d="M21.0464 13.945V15.4726C20.8109 15.4567 20.5773 15.4186 20.3487 15.3589C18.9359 15.0182 17.7687 14.0091 17.2092 12.6447H19.7696C20.4736 12.6474 21.0437 13.228 21.0464 13.945Z"
				fill="black"
			/>
			<path
				opacity="0.2"
				d="M21.0464 13.945V15.4726C20.8109 15.4567 20.5773 15.4186 20.3487 15.3589C18.9359 15.0182 17.7687 14.0091 17.2092 12.6447H19.7696C20.4736 12.6474 21.0437 13.228 21.0464 13.945Z"
				fill="black"
			/>
			<path
				opacity="0.2"
				d="M20.3487 13.945V15.3589C18.9359 15.0182 17.7687 14.0091 17.2092 12.6447H19.0719C19.776 12.6474 20.346 13.228 20.3487 13.945Z"
				fill="black"
			/>
			<path
				d="M6.27882 12.6447H19.0699C19.7762 12.6447 20.3487 13.2278 20.3487 13.9471V26.9738C20.3487 27.6931 19.7762 28.2762 19.0699 28.2762H6.27882C5.57254 28.2762 5 27.6931 5 26.9738V13.9471C5 13.2278 5.57256 12.6447 6.27882 12.6447Z"
				fill="url(#paint0_linear_teams)"
			/>
			<path
				d="M16.0398 17.6027H13.4829V24.6938H11.8538V17.6027H9.30872V16.2272H16.0398V17.6027Z"
				fill="white"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_teams"
					x1="7.66639"
					y1="11.6271"
					x2="17.9591"
					y2="29.1312"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#5A62C3" />
					<stop offset="0.5" stopColor="#4D55BD" />
					<stop offset="1" stopColor="#3940AB" />
				</linearGradient>
			</defs>
		</svg>
	) : (
		<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M25.9254 16.9079H33.6744C34.4065 16.9079 35 17.5123 35 18.2579V25.4462C35 28.1865 32.8188 30.4078 30.1282 30.4078H30.1051C27.4145 30.4082 25.233 28.1872 25.2326 25.4469C25.2326 25.4467 25.2326 25.4465 25.2326 25.4462V17.6135C25.2326 17.2238 25.5428 16.9079 25.9254 16.9079Z"
				fill="#5059C9"
			/>
			<path
				d="M31.1625 15.4868C32.8964 15.4868 34.3021 14.0553 34.3021 12.2894C34.3021 10.5236 32.8964 9.09207 31.1625 9.09207C29.4286 9.09207 28.023 10.5236 28.023 12.2894C28.023 14.0553 29.4286 15.4868 31.1625 15.4868Z"
				fill="#5059C9"
			/>
			<path
				d="M21.3953 15.4868C23.8999 15.4868 25.9302 13.4191 25.9302 10.8684C25.9302 8.31773 23.8999 6.25 21.3953 6.25C18.8908 6.25 16.8605 8.31773 16.8605 10.8684C16.8605 13.4191 18.8908 15.4868 21.3953 15.4868Z"
				fill="#7B83EB"
			/>
			<path
				d="M27.4421 16.9079H14.651C13.9276 16.9261 13.3554 17.5375 13.3722 18.2742V26.473C13.2712 30.894 16.7056 34.5628 21.0466 34.671C25.3875 34.5628 28.8219 30.894 28.7209 26.473V18.2742C28.7377 17.5375 28.1655 16.9261 27.4421 16.9079Z"
				fill="#7B83EB"
			/>
			<path
				opacity="0.1"
				d="M21.7441 16.9079V28.3971C21.7406 28.9239 21.4271 29.3972 20.9487 29.5978C20.7964 29.6635 20.6327 29.6973 20.4673 29.6973H13.986C13.8953 29.4628 13.8115 29.2284 13.7418 28.9868C13.4976 28.1715 13.3729 27.3239 13.372 26.4715V18.2721C13.3552 17.5366 13.9265 16.9261 14.6487 16.9079H21.7441Z"
				fill="black"
			/>
			<path
				opacity="0.2"
				d="M21.0464 16.9079V29.1076C21.0464 29.276 21.0132 29.4427 20.9487 29.5978C20.7518 30.085 20.287 30.4043 19.7697 30.4078H14.3139C14.1953 30.1734 14.0836 29.9389 13.986 29.6973C13.8883 29.4557 13.8115 29.2284 13.7418 28.9868C13.4976 28.1715 13.3729 27.3239 13.372 26.4715V18.2721C13.3552 17.5366 13.9265 16.9261 14.6487 16.9079H21.0464Z"
				fill="black"
			/>
			<path
				opacity="0.2"
				d="M21.0464 16.9079V27.6865C21.0411 28.4024 20.4726 28.9814 19.7697 28.9868H13.7418C13.4976 28.1715 13.3729 27.3239 13.372 26.4715V18.2721C13.3552 17.5366 13.9265 16.9261 14.6487 16.9079H21.0464Z"
				fill="black"
			/>
			<path
				opacity="0.2"
				d="M20.3487 16.9079V27.6865C20.3434 28.4024 19.7749 28.9814 19.072 28.9868H13.7418C13.4976 28.1715 13.3729 27.3239 13.372 26.4715V18.2721C13.3552 17.5366 13.9265 16.9261 14.6487 16.9079H20.3487Z"
				fill="black"
			/>
			<path
				opacity="0.1"
				d="M21.7443 13.2344V15.4726C21.6257 15.4797 21.5141 15.4868 21.3955 15.4868C21.2769 15.4868 21.1653 15.4797 21.0467 15.4726C20.8112 15.4567 20.5776 15.4186 20.349 15.3589C18.9362 15.0182 17.769 14.0091 17.2095 12.6447C17.1132 12.4156 17.0384 12.1777 16.9862 11.9342H20.4676C21.1716 11.9369 21.7417 12.5175 21.7443 13.2344Z"
				fill="black"
			/>
			<path
				opacity="0.2"
				d="M21.0464 13.945V15.4726C20.8109 15.4567 20.5773 15.4186 20.3487 15.3589C18.9359 15.0182 17.7687 14.0091 17.2092 12.6447H19.7696C20.4736 12.6474 21.0437 13.228 21.0464 13.945Z"
				fill="black"
			/>
			<path
				opacity="0.2"
				d="M21.0464 13.945V15.4726C20.8109 15.4567 20.5773 15.4186 20.3487 15.3589C18.9359 15.0182 17.7687 14.0091 17.2092 12.6447H19.7696C20.4736 12.6474 21.0437 13.228 21.0464 13.945Z"
				fill="black"
			/>
			<path
				opacity="0.2"
				d="M20.3487 13.945V15.3589C18.9359 15.0182 17.7687 14.0091 17.2092 12.6447H19.0719C19.776 12.6474 20.346 13.228 20.3487 13.945Z"
				fill="black"
			/>
			<path
				d="M6.27882 12.6447H19.0699C19.7762 12.6447 20.3487 13.2278 20.3487 13.9471V26.9738C20.3487 27.6931 19.7762 28.2762 19.0699 28.2762H6.27882C5.57254 28.2762 5 27.6931 5 26.9738V13.9471C5 13.2278 5.57256 12.6447 6.27882 12.6447Z"
				fill="#5059C9"
			/>
			<path
				d="M16.0398 17.6027H13.4829V24.6938H11.8538V17.6027H9.30872V16.2272H16.0398V17.6027Z"
				fill="white"
			/>
		</svg>
	);
};
